<div class="verify">
  <div class="verify__card">
    <h2 class="verify__title">{{ "verify.Title" | translate }}</h2>
    <p class="verify__lead">
      {{ "verify.SentTo" | translate }} <strong>{{ email || 'your email' }}</strong>
      {{ "verify.SentToSuffix" | translate }}
    </p>

    <input
      class="form-control verify__input"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      [placeholder]="'verify.CodePlaceholder' | translate"
      [(ngModel)]="code"
      (keyup.enter)="verify()"
    />

    <button class="btn btn-primary w-100 mt-3" (click)="verify()" [disabled]="verifying">
      {{ verifying ? 'Verifying…' : 'Verify' }}
    </button>

    <button class="btn btn-link w-100 mt-2" (click)="resend()" [disabled]="resending">
      {{ resending ? 'Sending…' : "Didn't get it? Resend code" }}
    </button>

    <a class="btn btn-link w-100" routerLink="/account/login">{{ "verify.BackToSignIn" | translate }}</a>
  </div>
</div>
